import styled, { css } from 'styled-components';

import { wave } from './wave';

export interface AnimatedDotProps {
  delay?: number;
  fill: string;
  fillActive: string;
  d: string;
  duration?: number;
}

export const ANIMATION_DURATION = 1.2;

const AnimatedDot = styled.path.attrs<AnimatedDotProps>(props => ({
  'aria-hidden': true,
  d: props.d,
}))<AnimatedDotProps>`
  transform-box: fill-box;
  transform-origin: center;
  fill: currentColor;
  color: ${({ fill }) => fill};
  stroke: none;
  ${({ fill, fillActive, duration = ANIMATION_DURATION }) => {
    const kf = wave({ fill, fillActive });
    return css`
      animation: ${kf} ${duration}s infinite linear;
    `;
  }}
  ${({ delay }) =>
    delay !== undefined &&
    css`
      animation-delay: ${delay}s;
    `}
`;

export default AnimatedDot;
